import * as yup from 'yup';

const USERS_IMPORT_VALIDATION_SCHEMA = yup.object().shape({
  importFrom: yup.string().required('Import from is required'),
});

export default USERS_IMPORT_VALIDATION_SCHEMA;
